(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-slideshow-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEurekaSlideshow = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      if (slides.length < 2) return;

      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const dots = Array.from(root.querySelectorAll('[data-go-to]'));
      const playPause = root.querySelector('[data-play-pause]');
      const viewport = root.querySelector('[data-viewport]');
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const pauseOnHover = root.dataset.pauseHover === 'true';
      const swipeEnabled = root.dataset.swipe === 'true';
      const speed = Math.max(parseInt(root.dataset.speed || '5000', 10), 1000);
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let current = 0;
      let timer = null;
      let paused = false;
      let touchStartX = null;

      const setSlide = (index, userInitiated = false) => {
        current = (index + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (userInitiated) restartAutoplay();
      };

      const stopAutoplay = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const startAutoplay = () => {
        stopAutoplay();
        if (!autoplayEnabled || paused || prefersReducedMotion) return;
        timer = window.setInterval(() => setSlide(current + 1), speed);
      };

      const restartAutoplay = () => {
        if (!autoplayEnabled) return;
        startAutoplay();
      };

      const goNext = () => setSlide(current + 1, true);
      const goPrev = () => setSlide(current - 1, true);

      prev?.addEventListener('click', goPrev);
      next?.addEventListener('click', goNext);
      dots.forEach((dot) => {
        dot.addEventListener('click', () => setSlide(parseInt(dot.dataset.goTo || '0', 10), true));
      });

      playPause?.addEventListener('click', () => {
        paused = !paused;
        playPause.classList.toggle('is-paused', paused);
        playPause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        paused ? stopAutoplay() : startAutoplay();
      });

      if (pauseOnHover) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        root.addEventListener('focusin', stopAutoplay);
        root.addEventListener('focusout', (event) => {
          if (!root.contains(event.relatedTarget)) startAutoplay();
        });
      }

      viewport?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goNext();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goPrev();
        } else if (event.key === ' ') {
          event.preventDefault();
          if (playPause) playPause.click();
        }
      });

      if (swipeEnabled) {
        viewport?.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0]?.clientX ?? null;
        }, { passive: true });

        viewport?.addEventListener('touchend', (event) => {
          if (touchStartX === null) return;
          const endX = event.changedTouches[0]?.clientX ?? touchStartX;
          const delta = endX - touchStartX;
          touchStartX = null;
          if (Math.abs(delta) < 45) return;
          if (delta < 0) goNext();
          if (delta > 0) goPrev();
        }, { passive: true });
      }

      root.addEventListener('mouseenter', () => {
        if (pauseOnHover) stopAutoplay();
      });

      setSlide(0);
      startAutoplay();
    };

    const boot = () => {
      document.querySelectorAll('.eureka-slideshow').forEach(initEurekaSlideshow);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target?.querySelector?.('.eureka-slideshow');
      if (root) initEurekaSlideshow(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
